import * as types from './mutation-types'
import {LOAD_DISCOUNT_LIST, LOAD_DISCOUNT_TYPES, SET_CURRENT_PROMOTION, UPDATE_PROMOTION} from "./mutation-types";

export default {


  [types.SET_PENDING_ORDERS_COUNT](state, count) {
    state.pendingOrdersCount = count
  },

  [types.SET_CURRENT_ORDER](state, data) {
    state.currentCheckout = data.checkout
    state.currentDeliveryInfo = data.delivery_info ?? null
  },

  [types.SET_ORDER_STATUS](state, data) {
    state.orderStatus = data
  },
  [types.SET_REVIEW_STATUS](state, data) {
    state.reviewStatus = data
  },
  [types.SET_CURRENT_PRODUCT_PLACES](state, data) {
    state.currentProductPlaces = data
  },
}
